import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCampaigns = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 20,
	fill: "none",
	viewBox: "0 0 22 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11 12 0 6l11-6 11 6-11 6Zm0 4L.575 10.325l2.1-1.15L11 13.725l8.325-4.55 2.1 1.15L11 16Zm0 4L.575 14.325l2.1-1.15L11 17.725l8.325-4.55 2.1 1.15L11 20Z" })
});
export { SvgCampaigns as ReactComponent };
